import { useSearchParams } from 'react-router-dom';

export function useQueryParam(queryName: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryParam = searchParams.get(queryName);

  const setQueryParam = (value: string | number | null) => {
    if (typeof value === 'number') {
      searchParams.set(queryName, String(value));
    } else if (value != null) {
      searchParams.set(queryName, value);
    } else {
      searchParams.delete(queryName);
    }

    setSearchParams(searchParams);
  };

  return [queryParam, setQueryParam] as const;
}

export default useQueryParam;
